export default __webpack_public_path__ + "static/media/marketplace-logo.61b01ad4.png";